import React from 'react';
import { cn } from '@/lib/utils';

export const TooltipProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>{children}</>
);

export const Tooltip: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>{children}</>
);

export const TooltipTrigger: React.FC<{ children: React.ReactNode; asChild?: boolean }> = ({
  children,
}) => <>{children}</>;

export const TooltipContent: React.FC<{
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  className?: string;
}> = ({ children, className }) => (
  <div className={cn('hidden', className)}>{children}</div>
);
